import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  KtList3hktaavzmj137 as KtList,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  nodeAtPath1cd3xt81xpfir as nodeAtPath,
  deepMergeObject115s855ldv6gd as deepMergeObject,
  toJsonMaprsmqd9lb9sfm as toJsonMap,
} from './JsonMap.mjs';
import { DeferredFragmentIdentifieryfmj5mbsp1mh as DeferredFragmentIdentifier } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/DeferredFragmentIdentifier.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function incrementalResult($this, incrementalResult) {
  var tmp = incrementalResult.get_wei43m_k$('data');
  var data = (tmp == null ? true : isInterface(tmp, KtMap())) ? tmp : THROW_CCE();
  var tmp_0 = incrementalResult.get_wei43m_k$('path');
  var path = (!(tmp_0 == null) ? isInterface(tmp_0, KtList()) : false) ? tmp_0 : THROW_CCE();
  var tmp_1 = $this.merged_1.get_wei43m_k$('data');
  var mergedData = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap()) : false) ? tmp_1 : THROW_CCE();
  if (!(data == null)) {
    var tmp_2 = nodeAtPath(mergedData, path);
    var nodeToMergeInto = (!(tmp_2 == null) ? isInterface(tmp_2, KtMutableMap()) : false) ? tmp_2 : THROW_CCE();
    deepMergeObject(nodeToMergeInto, data);
    var tmp0 = $this._deferredFragmentIdentifiers_1;
    var tmp_3 = incrementalResult.get_wei43m_k$('label');
    // Inline function 'kotlin.collections.plusAssign' call
    var element = new (DeferredFragmentIdentifier())(path, (tmp_3 == null ? true : typeof tmp_3 === 'string') ? tmp_3 : THROW_CCE());
    tmp0.add_utx5q5_k$(element);
  }
}
var V0_1IncrementalResultsMergerClass;
function V0_1IncrementalResultsMerger() {
  if (V0_1IncrementalResultsMergerClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp._merged_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        this.merged_1 = this._merged_1;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableSetOf' call
        tmp_0._deferredFragmentIdentifiers_1 = LinkedHashSet().new_kotlin_collections_LinkedHashSet_ahyf7j_k$();
        this.deferredFragmentIdentifiers_1 = this._deferredFragmentIdentifiers_1;
        this.hasNext_1 = true;
        this.isEmptyResponse_1 = false;
      }
      get_deferredFragmentIdentifiers_ylh6by_k$() {
        return this.deferredFragmentIdentifiers_1;
      }
      get_hasNext_csdx38_k$() {
        return this.hasNext_1;
      }
      get_isEmptyResponse_kjiv23_k$() {
        return this.isEmptyResponse_1;
      }
      merge_wv0l0k_k$(part) {
        return this.merge_uizp56_k$(toJsonMap(part));
      }
      merge_uizp56_k$(part) {
        if (this.merged_1.isEmpty_y1axqb_k$()) {
          // Inline function 'kotlin.collections.plusAssign' call
          this._merged_1.putAll_wgg6cj_k$(part);
          return this.merged_1;
        }
        var tmp = part.get_wei43m_k$('incremental');
        var incremental = (!(tmp == null) ? isInterface(tmp, KtList()) : false) ? tmp : null;
        if (incremental == null) {
          this.isEmptyResponse_1 = true;
        } else {
          this.isEmptyResponse_1 = false;
          // Inline function 'kotlin.collections.mutableListOf' call
          var mergedErrors = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          // Inline function 'kotlin.collections.mutableListOf' call
          var mergedExtensions = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s = incremental.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var incrementalResult_0 = _iterator__ex2g4s.next_20eer_k$();
            incrementalResult(this, incrementalResult_0);
            var tmp_0 = incrementalResult_0.get_wei43m_k$('errors');
            var tmp0_safe_receiver = (!(tmp_0 == null) ? isInterface(tmp_0, KtList()) : false) ? tmp_0 : null;
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.collections.plusAssign' call
              addAll(mergedErrors, tmp0_safe_receiver);
            }
            var tmp_1 = incrementalResult_0.get_wei43m_k$('extensions');
            var tmp1_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap()) : false) ? tmp_1 : null;
            if (tmp1_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.collections.plusAssign' call
              mergedExtensions.add_utx5q5_k$(tmp1_safe_receiver);
            }
          }
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!mergedErrors.isEmpty_y1axqb_k$()) {
            // Inline function 'kotlin.collections.set' call
            this._merged_1.put_4fpzoq_k$('errors', mergedErrors);
          } else {
            this._merged_1.remove_gppy8k_k$('errors');
          }
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!mergedExtensions.isEmpty_y1axqb_k$()) {
            var tmp0 = this._merged_1;
            var tmp2 = 'extensions';
            // Inline function 'kotlin.collections.set' call
            var value = mapOf(to('incremental', mergedExtensions));
            tmp0.put_4fpzoq_k$(tmp2, value);
          } else {
            this._merged_1.remove_gppy8k_k$('extensions');
          }
        }
        var tmp_2 = this;
        var tmp_3 = part.get_wei43m_k$('hasNext');
        var tmp2_elvis_lhs = (tmp_3 == null ? true : typeof tmp_3 === 'boolean') ? tmp_3 : THROW_CCE();
        tmp_2.hasNext_1 = tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
        return this.merged_1;
      }
      reset_5u6xz3_k$() {
        this._merged_1.clear_j9egeb_k$();
        this._deferredFragmentIdentifiers_1.clear_j9egeb_k$();
        this.hasNext_1 = true;
        this.isEmptyResponse_1 = false;
      }
    }
    initMetadataForClass($, 'V0_1IncrementalResultsMerger', V0_1IncrementalResultsMerger);
    V0_1IncrementalResultsMergerClass = $;
  }
  return V0_1IncrementalResultsMergerClass;
}
//region block: exports
export {
  V0_1IncrementalResultsMerger as V0_1IncrementalResultsMerger33xbt4nwq2a5,
};
//endregion

//# sourceMappingURL=V0_1IncrementalResultsMerger.mjs.map
